import { Icon } from 'semantic-ui-react';
import ConfirmModal from '../common/ConfirmModal';

const ClothingDeleteConfirmModal = ({
    isOpen,
    onClose,
    onConfirm,
    isDeleting,
    deleteError
}) => {
    return (
        <ConfirmModal
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={onConfirm}
            title="Delete Clothing Item"
            titleIconName="trash"
            titleIconColor="red"
            confirmText="Delete"
            cancelText="Cancel"
            variant="danger"
            isLoading={isDeleting}
            loadingText="Deleting..."
            confirmDisabled={isDeleting}
            closeOnOverlay={!isDeleting}
        >
            <p>Are you sure you want to delete this item?</p>
            {deleteError && (
                <div className="confirm-modal-error">
                    <Icon name="warning circle" /> {deleteError}
                </div>
            )}
        </ConfirmModal>
    );
};

export default ClothingDeleteConfirmModal;
